export const posterTypesOptions = [
  {
    label: "📝 Text",
    value: "text",
  },
  {
    label: "🔗 Link",
    value: "link",
  },
  {
    label: "🖼️ Photo",
    value: "photo",
  },
  {
    label: "🎥 Video",
    value: "video",
  },
];
